import * as Sentry from '@sentry/react';
import { toast } from '../notifications/toast';

const EVENT_PLAY_DELAY_MSEC = 1000;

export function isVideoPlaying(video: HTMLMediaElement) {
  return video.currentTime > 0 && !video.paused && !video.ended;
}

export function toastVideoError() {
  toast('Can not play media. Try again after reloading the page.', {
    type: 'error',
  });
}

export async function onTimestampClick(
  videoElem: HTMLMediaElement,
  timestamp: number
) {
  videoElem.currentTime = Math.max(timestamp, 0);

  if (isVideoPlaying(videoElem)) {
    videoElem.pause();
    await new Promise((r) => setTimeout(r, EVENT_PLAY_DELAY_MSEC));
    // Below promise will be rejected if pause operation was trigger before play
    // could resolve and video could start playing. This may happen if the video
    // playing itself had problems probably due to app being offline or video link
    // being expired, or due to markers being clicked quickly in succession.
    videoElem.play().catch((error) => {
      toastVideoError();

      // Capture as a message for analytics as this scenario does not mean
      // there is an issue with application
      Sentry.captureMessage('Failed to play media on marker click', {
        extra: {
          error,
        },
      });
    });
  }
}
